import { render } from "./PhoneIcon.vue?vue&type=template&id=6229e32e"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PhoneIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6229e32e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6229e32e', __exports__)) {
    api.reload('6229e32e', __exports__)
  }
  
  module.hot.accept("./PhoneIcon.vue?vue&type=template&id=6229e32e", () => {
    api.rerender('6229e32e', render)
  })

}


export default __exports__